import React from "react"

export default function RemoveMember() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="6.64746" cy="6.47559" r="6" fill="#FF3B30" />
      <g clipPath="url(#clip0_86_7576)">
        <path d="M7.77248 6.47607L9.33607 4.91248C9.52795 4.72061 9.52795 4.40951 9.33607 4.21748L8.98857 3.86998C8.7967 3.67811 8.48561 3.67811 8.29357 3.86998L6.72998 5.43357L5.16639 3.86998C4.97451 3.67811 4.66342 3.67811 4.47139 3.86998L4.12389 4.21748C3.93201 4.40936 3.93201 4.72045 4.12389 4.91248L5.68748 6.47607L4.12389 8.03967C3.93201 8.23154 3.93201 8.54264 4.12389 8.73467L4.47139 9.08217C4.66326 9.27404 4.97451 9.27404 5.16639 9.08217L6.72998 7.51857L8.29357 9.08217C8.48545 9.27404 8.7967 9.27404 8.98857 9.08217L9.33607 8.73467C9.52795 8.54279 9.52795 8.2317 9.33607 8.03967L7.77248 6.47607Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_86_7576">
          <rect width="5.5" height="8" fill="white" transform="translate(3.97998 2.47607)" />
        </clipPath>
      </defs>
    </svg>
  )
}